import { useEffect } from "react"

// Ecrit un cookie avec date d'expiration en jours
function writeCookie(name, value, days = 30, domain) {
  try {
    const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString()
    const domainAttr = domain ? `; domain=${domain}` : ""
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax${domainAttr}`
  } catch (_) {
    // noop
  }
}

// Lit les paramètres utm_* depuis l'URL courante et retourne un objet { utm: { ... } }
export function parseUtmFromUrl(url) {
  try {
    const href = url || (typeof window !== "undefined" ? window.location.href : "")
    const u = new URL(href)
    const params = u.searchParams
    const utm = {}
    let ionisPresent = false

    // Itère sur tous les paramètres, ne prend que ceux qui commencent par utm_
    for (const [key, val] of params.entries()) {
      if (key.toLowerCase().startsWith("utm_")) {
        const cleanKey = key.substring(4) // retire le préfixe utm_
        if (cleanKey.toLowerCase() === "ionis") {
          ionisPresent = true
          // utm_ionis est traité comme booléen: présent => true
          utm[cleanKey] = true
        } else {
          utm[cleanKey] = val || ""
        }
      }
    }

    // Si utm_ionis n'est pas présent dans l'URL, poser le booléen à false
    if (!ionisPresent) {
      utm.ionis = false
    }

    return { utm }
  } catch (_) {
    return { utm: { ionis: false } }
  }
}

// Hook: à l'initialisation, crée/actualise le cookie _ionis_user_data basé sur les utm_* de l'URL
// Ne gère que l'objet utm comme demandé.
export default function useUtmCookie(options = {}) {
  const {
    cookieName = "_ionis_user_data",
    days = 30,
    getUrl, // option pour surcharger la source de l'URL: () => string
  } = options

  useEffect(() => {
    if (typeof document === "undefined") return

    const href = typeof getUrl === "function" ? getUrl() : (typeof window !== "undefined" ? window.location.href : "")
    const hostname = (typeof window !== "undefined" && window.location && window.location.hostname) ? window.location.hostname : ""
    const parsed = parseUtmFromUrl(href)

    // Ne créer le cookie que s'il y a au moins une clé UTM
    const hasUtm = parsed && parsed.utm && Object.keys(parsed.utm).length > 0
    if (!hasUtm) return

    const value = JSON.stringify(parsed)
    // Limiter la création du cookie à ionis.io et localhost
    const isLocalhost = hostname === "localhost" || hostname === "127.0.0.1"
    const isIonis = hostname.endsWith("ionis.io")
    if (!isLocalhost && !isIonis) return
    const domain = isIonis ? ".ionis.io" : undefined
    writeCookie(cookieName, value, days, domain)
  }, [cookieName, days, getUrl])
}
